export class DerivationMapperError extends Error {
    constructor() {
        super("Error mapping derivation");
        this.name = "DerivationMapperError";
    }
}